import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";
import { Fragment, useEffect } from "react";
import PrivateRoute from "./PrivateRoute";
import { dashboardSideBar, sideBarLinks } from "./utils/constants";
import ReportTwo from "./pages/Report/ReportTwo";
import Report from "./pages/Report";
import ReportOne from "./pages/Report/ReportOne";
import DefaultDashboard from "./layout/DefaultDashboard";
import PublicRoutes from "./layout/PublicRoutes";
import Cookies from "js-cookie";
import {
  NotFound,
  Dashboard,
  Login,
  ForgotPassword
} from "./pages/pageListAsync";
import UserProfile from "./components/Profile";
import { Toaster } from "react-hot-toast";
import YouTubeLinkModal from "./components/modals/YouTubeLinkModal";

function App() {
  const location = useLocation();
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  const getAccessToken = () => {
    const params = new URLSearchParams(location.search);
    const data = params.get("accessToken");
    if (data) {
      Cookies.set("accessToken1", data);
    }
  };
  useEffect(() => {
    getAccessToken();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ToastContainer toastStyle={{ zIndex: 9999 }} />
      <YouTubeLinkModal />
      <Toaster />
      <Routes>
        <Route
          path="login"
          element={
            <PublicRoutes>
              {" "}
              <Login />
            </PublicRoutes>
          }
        ></Route>
        <Route
          path="forgot-password"
          element={
            <PublicRoutes>
              {" "}
              <ForgotPassword />
            </PublicRoutes>
          }
        ></Route>
        <Route
          path="/"
          index
          element={
            <Fragment>
              <Login />
            </Fragment>
          }
        ></Route>
        <Route
          path="/"
          element={
            <PublicRoutes>
              <DefaultDashboard />
            </PublicRoutes>
          }
        >
          {sideBarLinks.map((item, index) => (
            <Route
              key={index}
              path={item.path}
              element={<Fragment>{item.component}</Fragment>}
            ></Route>
          ))}
        </Route>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index path="dashboard" element={<Report />}></Route>
          <Route index path="profile" element={<UserProfile />}></Route>
          <Route path="/report/:id" element={<ReportOne />}></Route>
          <Route path="/report/:id/:1231" element={<ReportTwo />}></Route>
          {dashboardSideBar.map(
            (item, index) =>
              item.title !== "Dashboard" && (
                <Route
                  key={index}
                  path={item.path}
                  element={<Fragment>{item.component}</Fragment>}
                ></Route>
              )
          )}

          <Route path="*" element={<NotFound />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
